import React from 'react';
import Gravatar from 'react-gravatar';

import { withRouter } from 'react-router-dom';

import BatteryStatus from './Status/Battery';
import TemperatureStatus from './Status/Temperature';
import PartialStatus from './Status/Partial';
import VisitsStatus from './Status/Visits';
import IssuesStatus from './Status/Issues';
import CanceledDeliveriesStatus from './Status/CanceledDeliveries';
import Formatter from '../psuite-js/helpers/formatter';
import VehicleHelper from './../helpers/Vehicle';
import {inject, observer} from "mobx-react/index";

const TrackList = ({ items, history, onItemClick, app_store }) => {

    const data = items.map((document, index) => {
        const vehicle = document.vehicle || {};
        const user = vehicle.user || {};
        const vehicle_contract = vehicle.vehicle_contract || {};
        const vehicle_type = vehicle.vehicle_type || {};
        const weight_occupation = document.weight_occupation;
        const delivery_type = document.delivery_type || {};
        const show_temperature = VehicleHelper.isCool(vehicle);
        const temperature = document.temperature || {};
        const location = document.location || {};

        const location_payload = location.payload || {};
        const device = location_payload.device || {};
        const vehicle_device = document.vehicle_device || {};

        const phones = user.phones || {};

        return (
            <tr style={{cursor: 'pointer'}} key={document.id} id={document.id} onClick={onItemClick.bind(this, document)}>
                <td>
                    <div className="user-info">
                        <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={32} default="mm" className="avatar" />
                        <div>
                            <h4>{user.display_name}</h4>
                            <small>{Formatter.formatPhone(phones.main)}</small>
                        </div>
                    </div>
                </td>

                <td>{document.id}</td>
                <td>{vehicle.id} - {vehicle_contract.name} / {vehicle_type.name} ({weight_occupation}%)</td>
                <td>{delivery_type.name}</td>

                {
                    app_store.configurations.use_temperature && (
                        <td><TemperatureStatus show={show_temperature}
                                               vehicleDevice={vehicle_device}
                                               temperature={temperature} /></td>
                    )
                }

                <td><BatteryStatus battery={device.battery} /></td>

                <td><PartialStatus id={document.id} /></td>

                <td><VisitsStatus id={document.id} /></td>

                <td>
                    <div className="td-container">
                        <CanceledDeliveriesStatus document={document} />
                        <IssuesStatus document={document} />
                    </div>
                </td>
            </tr>
        );
    });

    return (
        <div style={{padding: '10px 16px'}}>
            <table className="table">
                <tbody>
                    {data}
                </tbody>
            </table>
        </div>
    );

}

let container = observer(TrackList);
container = inject(['app_store'])(container);

export default withRouter(container);



// WEBPACK FOOTER //
// ./src/components/TrackList.js